import api from '../api';
import { User } from '../../types';

export const userService = {
  async getAll(): Promise<User[]> {
    const response = await api.get('/admin/users');
    return response.data;
  },

  async getById(id: string): Promise<User> {
    const response = await api.get(`/admin/users/${id}`);
    return response.data;
  },

  async update(id: string, data: Partial<User>): Promise<User> {
    const response = await api.put(`/admin/users/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/admin/users/${id}`);
  },

  async resetPassword(id: string, newPassword: string): Promise<void> {
    await api.post(`/admin/users/${id}/reset-password`, { newPassword });
  },

  async getPendingDeletions(): Promise<any> {
    const response = await api.get('/admin/users/deletions/pending');
    return response.data;
  },

  async executeDeletion(userId: string): Promise<void> {
    await api.post(`/admin/users/deletions/${userId}/execute`);
  },

  async cancelDeletion(userId: string): Promise<void> {
    await api.post(`/admin/users/deletions/${userId}/cancel`);
  },

  async sendDeletionReminders(daysBeforeDeletion: number = 7): Promise<void> {
    await api.post('/admin/users/deletions/send-reminders', { daysBeforeDeletion });
  },
};
